import { useEffect, useState } from "react";
import { dds } from "./ddsClient";

/**
 * Observable DDS WebSocket connection state.
 *
 * Backed by @aelive/dds-client's connection API (OPUS-1440). Before that
 * existed, nothing was exposed at all, so useDDSCollection had to INFER
 * reconnects from `online`/`visibilitychange` — which fires on a healthy tab
 * that was merely hidden, and misses a real reconnect on a visible one.
 *
 * Returns null when the client has no WS transport (so callers can no-op).
 */
export function useDDSConnection() {
  const [state, setState] = useState(() => dds?.connection?.getState?.() || null);

  useEffect(() => {
    const conn = dds?.connection;
    if (!conn?.subscribe) return undefined;
    return conn.subscribe(setState);
  }, []);

  return state;
}

/** Close the breaker and retry immediately — wire to a "Retry" button. */
export const reconnectDDS = () => dds?.connection?.reconnectNow?.();
